import { Button, Select, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useLoaderData, useNavigate } from 'react-router-dom'
import Axios from '../utils/axios'
import Pagination from '../../globalComponents/Pagination'


const columns = [
  {
    title: 'Code',
    dataIndex: 'code',
    key: 'code',
    // sorter: (a, b) => a.code * 1 - b.code * 1,
    sortOrder: 'ascend',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Action',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/accounting/accounts/' + record.code}>
        SETUP
      </Link>
    )
  }
]


const ChartsOfAccounts = () => {
  const loader = useLoaderData();
  const navigate = useNavigate();
  const [items, setItems] = useState(loader);
  const [paginations, setPaginations] = useState({pageSize: 100, page: 1});


  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/accounting/accounts/'+record.code)
    };
  }

  async function fetchUserList(pagination_) {

    return Axios(`accounts/search?pagination=${JSON.stringify(pagination_)}`)
      .then((response) => response.data)
      .then((res) => {
        setItems(res);
        console.log(res)    
      });
  }
 
  useEffect(() => {
    // const totalPages = Math.ceil(paginations.total / paginations.pageSize);
    // if (paginations.page < 1) setPaginations({...paginations, page: 1});
    // if (paginations.page > totalPages) setPaginations({...paginations, page: totalPages});
    const offset = (paginations.page - 1) * paginations.pageSize;
    let pagination_ = {offset, pageSize: paginations.pageSize};
    // let filters = {search: {by: searchBy, values: search, filters: selectedFilters}};
    fetchUserList(pagination_);
  },[paginations])


  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Charts of Accounts</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            className='w-96'
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/accounts/new'} className='w-full'>
              New
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination paginations={paginations} setPaginations={setPaginations} total={items.totalRows} />
          </div>
        </div>
      </div>
      <Table
        sticky={false}
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={items.all}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'code'}
      />
    </div>
  )
}

export default ChartsOfAccounts
